import { AuthenticatedState } from 'core/data/authenticated';
import React from 'react';
import { Redirect } from 'react-router-dom';

export default function Index(): JSX.Element {
  return <Redirect to='/app/manage' />;
}
